import { createContext } from 'react';
import { OpenedPanel } from '../../../types/openedPanels';

export const EditorOpenedPanelsContext = createContext<OpenedPanel[]>([]);
